import { ILayout } from './LayoutModels'

const asideTheme: any = localStorage.getItem('kt_theme_mode_value')

/**
 * Resolves 'system' theme to actual 'dark' or 'light' based on system preference
 * @param theme - Theme value from localStorage ('system', 'dark', 'light', or null)
 * @returns Resolved theme ('dark' or 'light')
 */
function resolveAsideTheme(theme: string | null): 'dark' | 'light' {
	if (theme === 'system') {
		// Check system preference
		if (typeof window !== 'undefined' && window.matchMedia) {
			return window.matchMedia('(prefers-color-scheme: dark)').matches
				? 'dark'
				: 'light'
		}
		// Fallback to light if matchMedia is not available
		return 'light'
	}
	// Return 'dark' if theme is 'dark', otherwise default to 'light'
	return theme === 'dark' ? 'dark' : 'light'
}

export const DefaultLayoutConfig: ILayout = {
	main: {
		type: 'default',
		primaryColor: '#009EF7',
		darkSkinEnabled: true,
	},
	loader: {
		display: true,
		type: 'default', // Set default|spinner-message|spinner-logo to hide or show page loader
	},
	scrolltop: {
		display: true,
	},
	header: {
		display: true, // Set true|false to show or hide Header
		width: 'fluid', // Set fixed|fluid to change width type
		left: 'menu',
		fixed: {
			desktop: true, // Set true|false to set fixed Header for desktop mode
			tabletAndMobile: true, // Set true|false to set fixed Header for tablet and mobile modes
		},
		menuIcon: 'svg',
	},
	megaMenu: {
		display: true, // Set true|false to show or hide Mega Menu
	},
	aside: {
		display: true,
		theme: resolveAsideTheme(asideTheme),
		menu: 'main',
		fixed: true,
		minimized: false,
		minimize: true,
		hoverable: true,
		menuIcon: 'svg',
	},
	content: {
		width: 'fixed', // Set fixed|fluid to change width
		layout: 'default',
	},
	toolbar: {
		display: true, // Display toolbar
		width: 'fluid', // Set fixed|fluid to change width type,
		fixed: {
			desktop: true,
			tabletAndMobileMode: true,
		},
		layout: 'toolbar1',
		layouts: {
			toolbar1: {
				height: '55px',
				heightAndTabletMobileMode: '55px',
			},
			toolbar2: {
				height: '75px',
				heightAndTabletMobileMode: '65px',
			},
			toolbar3: {
				height: '55px',
				heightAndTabletMobileMode: '55px',
			},
			toolbar4: {
				height: '65px',
				heightAndTabletMobileMode: '65px',
			},
			toolbar5: {
				height: '75px',
				heightAndTabletMobileMode: '65px',
			},
		},
	},
	footer: {
		width: 'fluid', // Set fixed|fluid to change width type
	},
	pageTitle: {
		display: true,
		breadCrumbs: true,
		description: false,
		layout: 'default',
		direction: 'row',
		responsive: true,
		responsiveBreakpoint: 'lg',
		responsiveTarget: '#kt_toolbar_container',
	},
}
